import { render, staticRenderFns } from "./CollectProfileDetail.vue?vue&type=template&id=70267949&scoped=true&"
import script from "./CollectProfileDetail.vue?vue&type=script&lang=js&"
export * from "./CollectProfileDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70267949",
  null
  
)

export default component.exports